import { Component, OnInit } from '@angular/core';

import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { DataService, HelperService, HTTPService } from 'app/services';
import { SwitchCorporateDialogComponent } from '../switch-corporate-dialog/switch-corporate-dialog.component';
import { Location } from '@angular/common';

@Component({
  selector: 'app-switch-location-dialog',
  templateUrl: './switch-location-dialog.component.html',
  styleUrls: ['./switch-location-dialog.component.scss'],
  providers: [DialogService],
})
export class SwitchLocationDialogComponent implements OnInit {
  currentShopId: string = '';
  defaultShopId: string = '';
  isProcessing: boolean = false;
  companyLocations: any[] = [];
  corporateId: string;
  isMarkPsDashboard = false;
  isMultiLocationEnabled = false;
  alDashboardUrl: string = 'https://aldashboard.myautoleap.com/#!/login';

  constructor(private helperService: HelperService, private dialogService: DialogService,
    private dialogConfig: DynamicDialogConfig, private dynamicDialogRef: DynamicDialogRef,
    private httpService: HTTPService, private dataService: DataService,private location: Location) { }

  ngOnInit() {
    const { isMultiLocationEnabled } = this.helperService.getCompany();
    this.isMultiLocationEnabled = isMultiLocationEnabled;
    this.corporateId = this.dialogConfig.data.corporateId;
    this.isMarkPsDashboard = this.dataService.isMarkPsDashboard
    this.getCompanyLocation();
  }

  getCompanyLocation() {
    const { employeeId } = this.helperService.getCompany();

    this.httpService.getShopLists({ employeeId, active: true }).then(
      (data) => {
        this.defaultShopId = data.defaultShopId;
        this.companyLocations = data.records || [];
        this.currentShopId = data.employee && data.employee.currentShopId;
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  openCorporateSwitchDialog() {
    this.handleClose();
    const ref = this.dialogService.open(SwitchCorporateDialogComponent, {
      styleClass: 'add-dialog export-report-dialog',
      closeOnEscape: false,
      showHeader: false,
      data: {},
    });

    const onClose = ref.onClose.subscribe(({ isSuccess }) => {
      if (isSuccess) {
      }

      onClose.unsubscribe();
    });
  }

  handleChange(currentShopId: string) {
    this.currentShopId = currentShopId;
  }

  handleClose(isSuccess: boolean = false) {
    this.dynamicDialogRef.close({ isSuccess });
  }

  handleSwitchLocation() {
    this.isProcessing = true;
    this.httpService.switchLocation({ currentShopId: this.currentShopId }).then(
      () => {
        this.replaceURL();
        localStorage.setItem('currentShop', this.currentShopId);
        this.handleClose(true);
        window.location.reload();
        this.helperService.showToaster('success', 'Successfully updated');
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  replaceURL(){
    if(this.dataService.path === '/reports/end-day-cash-drawer-details'){
      this.location.replaceState(`reports/end-day-cash-drawer`);
    }
  }

  redirectToALDashboard() {
    if (this.dataService.isMarkPsDashboard) {
      let url = this.alDashboardUrl;
      if (this.dataService.currentShopId && this.dataService.partnerId && this.dataService.userEmail) {
        let locationId = this.dataService.currentShopId;
        locationId = locationId.substring(locationId.length - 8);
        url = `${this.alDashboardUrl}?email=${this.dataService.userEmail}&key=${this.dataService.partnerId}&locationId=${locationId}`
      }
      window.open(url, '_blank');
    }
  }
}
